"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultErrorFactory = void 0;
const ValidationError_1 = require("./ValidationError");
/**
 * The deafult erorr factory, which takes an error message and returns a newly constructed Error for that message.
 *
 * @param {string} message - The error message that should be thrown.
 * @returns {Error} The constructed error.
 */
const defaultErrorFactory = (message) => new ValidationError_1.ValidationError(message);
exports.defaultErrorFactory = defaultErrorFactory;
